import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, reduxForm } from 'redux-form'
import { Icon, Grid } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import {
  CONDITION,
  financingAvailableSelected,
  interiorAccessSelected,
  vacantOccupancyStatus,
} from '../../../constants/filters'
import ConditionFiltersContent from './content'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const { Row, Column } = Grid
export const BASE_ELM_ID = 'condition_filters'
export const FORM_NAME = 'conditionFilters'

export const ConditionFiltersHeader = () => (
  <Row data-elm-id={`${BASE_ELM_ID}_header`} className={cx('u-mt-1', 'u-mb-3')}>
    <Column>
      Most properties on Auction.com are sold "Cash only" and "As-is," and many
      are occupied. Use these filters to potentially reduce your risk.
    </Column>
  </Row>
)

export class ConditionFiltersForm extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    submitForms: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    featureFlags: PropTypes.object.isRequired,
  }

  submitForms = () => {
    this.props.submitForms(FORM_NAME)
  }

  onClose = () => this.props.onClose(null, { filtername: CONDITION })

  updateFilters = filters => {
    const newFilters = {
      offset: 0,
      accessAvailable: !!filters.access_available && interiorAccessSelected,
      financingAvailable:
        !!filters.financing_available && financingAvailableSelected,
      occupancyStatus: filters.occupancy_status ? vacantOccupancyStatus : [],
      inspectionAllowed: filters.inspectionAllowed ? 'y' : false,
    }
    this.props.updateFilters(newFilters)
  }

  render() {
    const { handleSubmit, featureFlags, ...rest } = this.props
    const privateSellerEnabled =
      featureFlags['fe.resi.search.private-seller-enabled']
    return (
      <Form
        className={cx('filter-root', 'ui', 'form')}
        data-elm-id={`${BASE_ELM_ID}_form`}
        onSubmit={handleSubmit(this.updateFilters)}
      >
        <Row>
          <Column className={cx('filter-close-button')}>
            <Icon
              data-elm-id={`${BASE_ELM_ID}_close_button`}
              className={cx('u-pointer-cursor')}
              onClick={this.onClose}
              iconStyle='light'
              name='times'
              fitted
            />
          </Column>
        </Row>

        {!privateSellerEnabled && (
          <>
            <ConditionFiltersHeader />
            <hr className={cx('separator', 'u-mb-3')} />
          </>
        )}
        <ConditionFiltersContent
          {...rest}
          privateSellerEnabled={privateSellerEnabled}
          elmId={BASE_ELM_ID}
          className={cx('filter-root')}
          submitForms={this.submitForms}
        />
      </Form>
    )
  }
}

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(ConditionFiltersForm)
